"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BooleanQuestion;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var AnswerContainer = (0, _styledComponents2.default)(_Button2.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    padding: 0;\n    padding-right: 20px;\n    text-transform: none;\n  }\n"])));
function BooleanQuestion(_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    error: error,
    question: question,
    answered: answer !== undefined
  }, _react2.default.createElement(Row, null, _react2.default.createElement(AnswerContainer, {
    onClick: function onClick() {
      return changeAnswer(true);
    },
    style: {
      marginRight: 20
    },
    role: "button"
  }, _react2.default.createElement(_Radio2.default, {
    checked: answer === true,
    id: question.id ? question.id + "Yes" : ""
  }), _react2.default.createElement(_QuestionText2.default, null, "Yes")), _react2.default.createElement(AnswerContainer, {
    role: "button",
    onClick: function onClick() {
      return changeAnswer(false);
    }
  }, _react2.default.createElement(_Radio2.default, {
    checked: answer === false,
    id: question.id ? question.id + "No" : ""
  }), _react2.default.createElement(_QuestionText2.default, null, "No"))));
}